"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    link: {
      color: "inherit",
      display: "block",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
      "&:hover, &:focus": {
        color: theme === null || theme === void 0 ? void 0 : theme.palette.primary.main
      }
    },
    linkSelected: {
      color: theme === null || theme === void 0 ? void 0 : theme.palette.primary.main
    }
  };
});

var MobileMetamenuItem = function MobileMetamenuItem(_ref) {
  var _clsx;

  var icon = _ref.icon,
      link = _ref.link,
      selected = _ref.selected,
      target = _ref.target,
      title = _ref.title;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("menu-01-mobile-metamenuitem")
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx2.default)("menu-01-mobile-metamenuitem__link", css.link, (_clsx = {}, _defineProperty(_clsx, css.linkSelected, selected), _defineProperty(_clsx, "menu-01-mobile-metamenuitem__link--selected", selected), _clsx)),
    href: link,
    target: target ? target : null
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx2.default)("menu-01-mobile-metamenuitem__title", css.title),
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
};

MobileMetamenuItem.propTypes = {
  icon: _propTypes.default.object,
  link: _propTypes.default.string.isRequired,
  selected: _propTypes.default.bool,
  target: _propTypes.default.string,
  title: _propTypes.default.string.isRequired
};
var _default = MobileMetamenuItem;
exports.default = _default;